/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_EsppPurchasePeriodParticipantResult } from '../models/PagedResultDto_EsppPurchasePeriodParticipantResult';
import type { Wealthlane_AwardService_AppServices_EsppAwardServices_PurchasePeriodInfoDto } from '../models/Wealthlane_AwardService_AppServices_EsppAwardServices_PurchasePeriodInfoDto';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodPurchasePeriodManipulatedResponseDto } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodPurchasePeriodManipulatedResponseDto';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_PurchasePeriodCreateDto } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_PurchasePeriodCreateDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EsppPurchasePeriodService {

    /**
     * @param offeringPeriodId
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodPurchasePeriodManipulatedResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAwardOfferingPeriodPurchasePeriod(
        offeringPeriodId: string,
        requestBody?: Array<Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_PurchasePeriodCreateDto>,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodPurchasePeriodManipulatedResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/purchase-period',
            path: {
                'offeringPeriodId': offeringPeriodId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodPurchasePeriodManipulatedResponseDto OK
     * @throws ApiError
     */
    public static patchApiAwardApiAwardOfferingPeriodPurchasePeriod(
        offeringPeriodId: string,
        requestBody?: Array<Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_PurchasePeriodCreateDto>,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodPurchasePeriodManipulatedResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/purchase-period',
            path: {
                'offeringPeriodId': offeringPeriodId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_PurchasePeriodCreateDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardOfferingPeriodPurchasePeriod(
        offeringPeriodId: string,
    ): CancelablePromise<Array<Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_PurchasePeriodCreateDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/purchase-period',
            path: {
                'offeringPeriodId': offeringPeriodId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @param purchasePeriodId
     * @returns Wealthlane_AwardService_AppServices_EsppAwardServices_PurchasePeriodInfoDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardOfferingPeriodPurchasePeriod1(
        offeringPeriodId: string,
        purchasePeriodId: string,
    ): CancelablePromise<Wealthlane_AwardService_AppServices_EsppAwardServices_PurchasePeriodInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/purchase-period/{purchasePeriodId}',
            path: {
                'offeringPeriodId': offeringPeriodId,
                'purchasePeriodId': purchasePeriodId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @param purchasePeriodId
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAwardOfferingPeriodPurchasePeriod(
        offeringPeriodId: string,
        purchasePeriodId: string,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/purchase-period/{purchasePeriodId}',
            path: {
                'offeringPeriodId': offeringPeriodId,
                'purchasePeriodId': purchasePeriodId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @param purchasePeriodId
     * @param eligibilityStatus
     * @param enrollmentStatus
     * @param isEnrolled
     * @param isInvitationEmailSent
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_EsppPurchasePeriodParticipantResult OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardOfferingPeriodPurchasePeriodEsppParticipants(
        offeringPeriodId: string,
        purchasePeriodId: string,
        eligibilityStatus?: Array<string>,
        enrollmentStatus?: Array<string>,
        isEnrolled?: boolean,
        isInvitationEmailSent?: boolean,
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_EsppPurchasePeriodParticipantResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/purchase-period/{purchasePeriodId}/espp-participants',
            path: {
                'offeringPeriodId': offeringPeriodId,
                'purchasePeriodId': purchasePeriodId,
            },
            query: {
                'EligibilityStatus': eligibilityStatus,
                'EnrollmentStatus': enrollmentStatus,
                'IsEnrolled': isEnrolled,
                'IsInvitationEmailSent': isInvitationEmailSent,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
